import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ajustarTamanhoFonteSre } from "../../../estilos/global";

export default function ProcessosVinculadosDocumento({ processos, documentoId, destacadoId, destacadoRef }) {
  return <Box sx={{ maxHeight: 260, overflowY: "auto", pr: 0.25 }}>
    {[{ categoria: "escola", titulo: "Escolas" }, { categoria: "mantenedora", titulo: "Mantenedoras" }].map(({ categoria, titulo }) => {
      const grupo = processos.filter((p) => (p.tipo_instituicao === "mantenedora" ? "mantenedora" : "escola") === categoria);
      if (!grupo.length) return null;
      return <Box component="section" aria-label={titulo} key={categoria} sx={{ mb: 1.5 }}>
        <Typography component="h3" sx={{ m: 0, mb: 0.5, color: "var(--sear-texto, #314967)", fontSize: ajustarTamanhoFonteSre("0.8rem"), fontWeight: 700 }}>{titulo} ({grupo.length})</Typography>
        {grupo.map((processo) => {
          const destacado = destacadoId != null && Number(processo.processo_id) === Number(destacadoId);
          const nome = processo.processo_nome || "Nome do processo indisponível";
          return <Box component={RouterLink} key={processo.processo_id} ref={destacado ? destacadoRef : null}
            to="/admin/processo" state={{ processoIdParaVisualizar: processo.processo_id, documentoIdParaDestacar: documentoId }}
            aria-label={"Visualizar processo " + nome}
            sx={{ display: "block", px: 1, py: 0.75, borderBottom: "1px solid var(--sear-borda, #d7e8f8)", textDecoration: "none", bgcolor: destacado ? "var(--sear-superficie-azul, #eaf4ff)" : "transparent", "&:hover": { bgcolor: "var(--sear-superficie-azul, #f2f8fe)" }, "&:focus-visible": { outline: "2px solid var(--sear-azul, #087cf0)", outlineOffset: -2 } }}>
            <Typography sx={{ color: "var(--sear-texto, #314967)", fontSize: ajustarTamanhoFonteSre("0.78rem"), overflowWrap: "anywhere" }}>{nome}</Typography>
          </Box>;
        })}
      </Box>;
    })}
  </Box>;
}
